import type { HttpTransport } from "@common/api/transport";
import type { Task } from "@common/types";
import type { ID } from "@common/types/api";
import type { ConsumedTaskItem } from "@common/types/Inventory";
import type { GroupedTasks, TaskInstructions } from "@common/types/Task";
import type { CurrencyPreference } from "@common/types/User";

export type CompleteTaskParams = {
  id: ID;
  completedAt?: string;
  final?: boolean;
  consumedItems?: ConsumedTaskItem[];
  harvestRecord?: {
    amountGrams: number;
    notes?: string;
    valuePerGram?: number;
    saveAsDefault?: boolean;
    currency: CurrencyPreference;
  };
};

type TodoTaskParams = {
  id: ID;
  // incompletedAt will be undefined if completing from the calendar
  incompleteAt?: string;
};

export type MoveTaskParams = { id: ID; isMove?: boolean } & (
  | {
      startDelta: number;
      endDelta: number;
      endDate?: never;
      startDate?: never;
    }
  | {
      endDate?: string;
      startDate?: string;
      startDelta?: never;
      endDelta?: never;
    }
);

export const createTasksApi = (http: HttpTransport) => ({
  completeTask: ({ id, ...params }: CompleteTaskParams) =>
    http.patch<Task>(`/api/tasks/${id}/complete`, params),

  completeTasks: ({ completedAt, ids }: { completedAt?: string; ids: number[] }) => {
    http.patch("/api/tasks/complete_bulk", { completedAt, ids });
  },

  fetchTask: (id: ID) => http.get<Task & TaskInstructions>(`/api/tasks/${id}`),

  fetchTasks: ({
    date,
    excludeHiddenPlantings,
    view
  }: {
    date: string;
    view: "date" | "week";
    excludeHiddenPlantings: boolean;
  }) =>
    http.get<GroupedTasks>(`/api/tasks`, {
      queryParams: { date, excludeHiddenPlantings, view }
    }),

  moveTask: ({ id, ...params }: MoveTaskParams) =>
    http.patch<Task>(`/api/tasks/${id}/move`, params),

  moveWarningTask: ({ id, ...params }: MoveTaskParams) =>
    http.patch<{ warning?: string }>(`/api/tasks/${id}/move_warning`, params),

  todoTask: ({ id, ...params }: TodoTaskParams) =>
    http.patch<Task>(`/api/tasks/${id}/todo`, params)
});
